import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ChartData, Charts } from '../../models/chart';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'app-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartsComponent implements OnInit {
  @Input() charts?: Observable<Charts>;
  @Input() inLive: boolean = false;
  charts$: BehaviorSubject<Charts>;
  chartList: any;
  constructor() {
    this.chartList = document.querySelectorAll('.item');
    this.chartList.forEach((item: any) => {
      item.addEventListener('dragstart', () => {
        item.classList.add('dragging');
      });
      item.addEventListener('dragend', () => {
        item.classList.remove('dragging');
      });
    });
    this.charts$ = new BehaviorSubject<Charts>([]);
    this.charts
      ?.pipe(
        tap((_) => {
          console.log('charts', _);

          this.charts$.next(_);
        })
      )
      .subscribe();
  }

  draggingItem: HTMLElement | null = null;

  ngOnInit(): void {}

  onDragStart(event: DragEvent): void {
    const target = event.target as HTMLElement;
    this.draggingItem = target;
    setTimeout(() => target.classList.add('dragging'), 0);
  }
  onDragEnd(event: DragEvent): void {
    const target = event.target as HTMLElement;
    target.classList.remove('dragging');
    this.draggingItem = null;
  }
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    const targets = event.target as HTMLElement;
    const target = this.draggingItem;
    if (target && target.classList.contains('item')) {
      const list = targets.closest('.sortable-list') as HTMLElement;
      const draggingElement = list.querySelector('.dragging') as HTMLElement;
      const siblings = Array.from(
        list.querySelectorAll('.item:not(.dragging)')
      ) as HTMLElement[];
      const nextSibling = siblings.find((sibling: HTMLElement) => {
        return (
          event.clientY <= sibling.offsetTop + sibling.offsetHeight / 2 &&
          event.clientX <= sibling.offsetLeft + sibling.offsetWidth / 2
        );
      });
      if (draggingElement && list) {
        list.insertBefore(draggingElement, nextSibling || null);
      }
    }
  }
  onDragEnter(event: DragEvent): void {
    event.preventDefault();
  }
}
